import React, { useCallback } from 'react';
import { MemoizeContainerDropdown } from './containerDropdown';
import { deleteContainerItemLevel, createContainerItemLevel } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { convertContainerData } from './helper';
import { useEvent } from '../../../hooks/useEvent';
import {containerPayload} from '../../../api/saveGBdata';
import { containerPayloadDelete } from '../../../api/deleteGBForm';

export default function Containers(props) {
  const {merchandiseId,invoiceId} = props
  const dispatch = useDispatch()
  let containersAtHeader = useSelector((state) => state.containerReducer?.containerList) || []
  let containerList = convertContainerData(containersAtHeader)
  let selectedContainerList =
    useSelector(
      (state) =>
        state.InvoicesReducer?.invoice?.merchandise[merchandiseId]?.containerNumberList
          ?.containerList
    ) || []

    const itemDeleted = useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemDeleted) || '0'
    const isFormDisabled =  itemDeleted == '1' ? true : false   

  const createContainer = useCallback(
    async (currentItem) => {
      const response=await containerPayload({
        merchandise: {
            [merchandiseId]: {
              invoiceId: invoiceId,
              containerNumberList: {
                containerList: [
                  {
                    id: currentItem.id,
                  },
                ],
              },
            },
          },
        })
       
      
      if (response?.data?.eventMessage?.code == 400) {
      } else {
        const resp =
        response.data.eventMessage?.invoice?.merchandise[merchandiseId]?.containerNumberList
          ?.containerList[0]
      const responseObj = { ...currentItem, ...resp }
      dispatch(createContainerItemLevel(invoiceId, merchandiseId, responseObj))
      }
    },
    [dispatch]
  )

  const deleteContainer = useCallback(
    async (currentItem) => {
        const data = await  containerPayloadDelete({
          merchandise: {
            [merchandiseId]: {
              invoiceId: invoiceId,
              containerNumberList: {
                containerList: [
                  {
                    containerAssociationId: currentItem.containerAssociationId,
                  },
                ],
              },
            },
          },
        })
      if (data?.data?.eventMessage?.code == 400) {
      } else {
        dispatch(deleteContainerItemLevel(merchandiseId, currentItem.containerAssociationId))
      }
    },
    [dispatch]
  )
  return (
    <MemoizeContainerDropdown
      disabled={isFormDisabled}
      selectedContainerList={selectedContainerList || []}
      onSelect={createContainer}
      onDelete={deleteContainer}
      invoiceId={invoiceId}
      merchandiseId={merchandiseId}
      dataSource={containerList || []}
    ></MemoizeContainerDropdown>
  )
}
